// @flow
const initialState = {
  id: undefined,
  name: '',
  key: ''
};
export default initialState;